import HtmlTooltip from "@mui/material/Tooltip";
import format from "date-fns/format";
import React, { useState } from "react";
import { BiInfoCircle } from "react-icons/bi";
import { HiOutlineTicket, HiQrcode } from "react-icons/hi";
import { Ticket } from "../../../models/Ticket";
import "./style.scss";
import ModalComponent from "../../../../features/ModalComponent";
import QrCodeModal from "../../../../features/QRcode";
import { useTranslation } from "react-i18next";

interface IProps {
  ticket: Ticket;
}

const LimitedTicketDesktop: React.FC<IProps> = ({ ticket }: IProps) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  return (
    <React.Fragment>
      <div className="limited-ticket flex-between border border-radius-6">
        <div className="flex-start">
          <HiOutlineTicket className="big-icon" />

          <div className="limited-ticket-body flex-column">
            <h3 className="flex-start-center">
              {ticket.name}
              <HtmlTooltip
                placement="right"
                title={
                  <React.Fragment>
                    <article
                      className="tooltip-description"
                      dangerouslySetInnerHTML={{ __html: ticket.description }}
                    ></article>
                  </React.Fragment>
                }
              >
                <b>
                  <BiInfoCircle className="tooltip-icon" />
                </b>
              </HtmlTooltip>
            </h3>
            <span>
              {t("wazny_od")}: {format(ticket.validfrom, "dd.mm.yyyy")}r. |  {t("wazny_do")}: {format(ticket.validto, "dd.mm.yyyy")}r.
            </span>

          </div>
        </div>

        <button onClick={() => setOpen(!open)} className="button medium padding-medium button-fill-main">
          {t("pokaz_kod_qr")}
          <HiQrcode className="icon" />
        </button>
      </div>

      {open && (
        <ModalComponent
          footer={false}
          open={open}
          closeModal={() => setOpen(false)}
          title={t("kod_qr")}
          onAccept={() => setOpen(false)}
        >
          <QrCodeModal trhId={ticket.trhId} name={ticket.name} />
          <button
            onClick={() => setOpen(!open)}
            className="button big padding-medium button-fill-second  center-button"
          >
            {t("gotowe_schowaj")}
          </button>
        </ModalComponent>
      )}
    </React.Fragment>
  );
};

export default LimitedTicketDesktop;
